/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-07-06 16:23:08
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-06-06 11:50:03
 */
const settings = [
	{
		path: '/settings',
		component: null,
		name: '设置',
		id: 5,
		parentId: 0,
		keepAlive: false,
		showBread: false,
		visible: true,
		useTemplate: false,
		redirect: '/settings/newRuleManage',
		children: [
			{
				path: 'newRuleManage',
				component: null,
				name: '新规则管理',
				parentId: 5,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
				redirect: '/settings/newRuleManage/list',
				children: [
					{
						path: 'list',
						component: 'settings/ruleManage/index.vue',
						name: '列表',
						parentId: 5,
						keepAlive: false,
						showBread: false,
						visible: false,
						useTemplate: false,
					},
					{
						path: 'drRuleSetting',
						component: 'settings/ruleManage/components/drRule/ruleSet/index.vue',
						name: '规则设置',
						parentId: 5,
						keepAlive: false,
						showBread: true,
						visible: false,
						useTemplate: false,
					},
				],
			},
			{
				path: 'tagManage',
				component: 'settings/tagManage/tagManage.vue',
				name: '标签管理',
				parentId: 5,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
			},
			{
				path: 'talentObtain',
				component: 'settings/talentObtain/index.vue',
				name: '自动找达人',
				parentId: 5,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
			},
			{
				path: 'message/index',
				component: 'settings/message/index',
				name: '消息提醒',
				parentId: 5,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
			},
		],
	},
];
export default settings;
